<template>
  <b-row>
    <div v-if="isBusy" style="margin: auto">
      <vue-loaders-ball-beat color="red" scale="1"></vue-loaders-ball-beat>
    </div>

    <sweet-modal ref="uploadyamlmodal" @close="closeNested" title="Upload YAML" width="60vw" modal-theme="dark">
      <div v-if="showNested">
        <b-form @submit="submitYaml">

          <b-form-group id="input-group-1" label="YAML FIle:" label-for="input-1"
            description="Upload a properly formated YAML file">
            <b-form-file v-model="yamluploaded" placeholder="Upload yaml file" drop-placeholder="Drop yaml file here..."
              style="margin-bottom: 13px" id="yamlupload"></b-form-file>
          </b-form-group>


          <b-button :disabled="isBusy || !yamluploaded" type="submit" style="width: 100%">Upload YAML</b-button>

        </b-form>

      </div>
    </sweet-modal>


    <sweet-modal ref="uploadjsonmodal" @close="closeNested" title="Upload JSON" width="60vw" modal-theme="dark">
      <div v-if="showNested">
        <b-form @submit="submitJson">

          <b-form-group id="input-group-1" label="JSON FIle:" label-for="input-1"
            description="Upload a properly formated JSON file">
            <b-form-file v-model="jsonuploaded" placeholder="Upload json file" drop-placeholder="Drop json file here..."
              style="margin-bottom: 13px" id="jsonupload"></b-form-file>
          </b-form-group>
          <b-button :disabled="isBusy" type="submit" style="width: 100%">Upload JSON</b-button>

        </b-form>
      </div>
    </sweet-modal>

    <sweet-modal ref="restartshopmodal" @close="closeNested" title="Install or Restart Bot" icon="warning"
      modal-theme="dark">
      <span v-if="bot_info">
        {{ bot_info.is_pending ? install_warning : restart_warning }}
      </span>

      <el-button :disabled="isBusy" type="danger" slot="button" @click="shopDoInit">Yes Am Sure</el-button>

      <el-button :disabled="isBusy" type="primary" slot="button" @click="cancelRestart">No take me back</el-button>
    </sweet-modal>

    <sweet-modal ref="slotmodal" @close="closeNested" title="Add Slot" width="60vw" modal-theme="dark">
      <b-form-group id="input-group-1" label="Name:" label-for="input-1"
        description="Your slot name, no spaces or special characters eg. my_slot">
        <b-form-input id="input-1" v-model="new_slot.name" placeholder="Enter Name" required></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Type:" label-for="input-2" description="Your slot type">
        <b-form-select id="input-3" v-model="new_slot.type" :options="slotTypes" required></b-form-select>
      </b-form-group>

      <b-button :disabled="isBusy || !new_slot.name" @click="submitSlot" style="width: 100%">Save</b-button>
    </sweet-modal>

    <sweet-modal ref="conditionmodal" @close="closeNested" title="Add Conditionx" width="60vw" modal-theme="dark">
      <div v-if="showNested">
        <b-form-group id="input-group-1" label="Slot:" label-for="input-1" description="Slot">
          <b-form-select id="input-1" v-model="new_condition.slot" value-field="name" text-field="name"
            :options="getNonDefaultSlots()" required></b-form-select>
        </b-form-group>

        <b-form-group id="input-group-2" label="Type:" label-for="input-2" description="Condition Type">
          <b-form-select id="input-3" v-model="new_condition.condition_type" :options="conditionTypes"
            required></b-form-select>
        </b-form-group>

        <b-form-group id="input-group-3" label="Value: " label-for="input-3" description="Your condition value"
          v-if="new_condition.condition_type == 'slot_value_in_list'">
          <b-form-input id="input-3" v-model="new_condition.value" required></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-3" label="Value:" label-for="input-3" description="Your condition value"
          v-if="new_condition.condition_type == 'slot_value_equal_to'">
          <b-form-input id="input-3" v-model="new_condition.value" required></b-form-input>
        </b-form-group>

        <b-button :disabled="isBusy || !new_condition.slot" @click="submitCondition" style="width: 100%">Save
          Condition</b-button>
      </div>
    </sweet-modal>

    <sweet-modal ref="valuemodal" @close="closeNested" title="Add Value" width="60vw" modal-theme="dark">
      <div v-if="showNested">
        <b-form-group id="input-group-1" label="Slot:" label-for="input-1" description="Slot">
          <b-form-select id="input-1" v-model="new_value.slot" value-field="name" text-field="name"
            :options="getNonDefaultSlots()" required></b-form-select>
        </b-form-group>


        <b-form-group id="input-group-3" label="Placeholder:" label-for="input-3" description="Your value placeholder">
          <b-form-input id="input-3" v-model="new_value.symbol" required></b-form-input>
        </b-form-group>

        <b-button :disabled="isBusy || !new_value.slot || !new_value.symbol" @click="submitValue" style="width: 100%">Save
          Value</b-button>
      </div>
    </sweet-modal>

    <sweet-modal ref="actionmodal" @close="closeNested" title="Add Action" width="60vw" modal-theme="dark">
      <div v-if="showNested">
        <b-form-group id="input-group-1" label="Action Type:" label-for="input-1" description="Action Type">
          <b-form-select id="input-1" v-model="selectedActionType" value-field="name" text-field="value"
            :options="actionTypes" required @change="changeActionType"></b-form-select>
        </b-form-group>


        <b-button :disabled="isBusy || !selectedActionType" @click="appendAction" style="width: 100%">Add 
            Action
        </b-button>


      </div>
    </sweet-modal>

    <b-tabs class="bg-dark" style="margin-top: 23px">

      <b-tab title="Publish Settings" style="width: 85vw" class="bg-dark">
        <b-card title="Bot Info" v-if="!isBusy" class="bg-dark">
          <b-form-group id="input-group-2" label="Action API:" label-for="input-2"
            description="Your Action API eg. https://example.yourdomain.com/api/v1">


            <h6><b>Name:</b> {{ bot_info.name }}</h6>

            <h6>
              <b>Updating:</b> <span v-if="!bot_info.is_updating"> No </span>
              <i v-if="bot_info.is_updating" class="fa fa-spinner fa-spin" style="font-size: 18px; margin-left: 3px"></i>
            </h6>

            <h6>
              <b>Accessible:</b> {{ bot_info.is_accessible ? "Yes" : "No" }}
            </h6>

            <h6>
              <b>Pending Deployment:</b> {{ bot_info.is_pending ? "Yes" : "No" }}
            </h6>
            <hr><br>

            <b-form-input id="input-2" v-model="bot_info.deployment_config.action_api" placeholder="Enter Action API URL"
              required></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-3" label="Action API KEY:" label-for="input-3"
            description="Your Action API KEY eg. 123456789 if your API requires one">
            <b-form-input id="input-3" type="password" v-model="bot_info.deployment_config.action_api_key"
              placeholder="Enter Action API KEY"></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-4" label="Twilio SID:" label-for="input-4"
            description="Your Twilio SID Token, if you have one">
            <b-form-input id="input-4" v-model="bot_info.deployment_config.twiliosid"
              placeholder="Enter Twilio SID"></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-5" label="Twilio Token:" label-for="input-5"
            description="Your Twilio Token, if you have one">
            <b-form-input id="input-5" type="password" v-model="bot_info.deployment_config.twiliotoken"
              placeholder="Enter Twilio Token"></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-6" label="Telegram Dev Token:" label-for="input-6"
            description="Your Telegram Dev Token, if you have one">
            <b-form-input id="input-6" v-model="bot_info.deployment_config.telegram_dev" type="password"
              placeholder="Telegram Dev Token"></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-7" label="Telegram Live Token:" label-for="input-7"
            description="Your Telegram Live Token, if you have one">
            <b-form-input id="input-7" type="password" v-model="bot_info.deployment_config.telegram_prod"
              placeholder="Enter Telegram Live Token"></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-8" label="Twilio Messaging Service SID:" label-for="input-8"
            description="Your Twilio Messaging Service SID, if you have one">
            <b-form-input id="input-8" v-model="bot_info.deployment_config.twiliomessagingsid"
              placeholder="Enter Twilio Messaging Service SID"></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-9" label="Twilio Content API Enabled:" label-for="input-9"
            description="Whether to use Twilio Content API for interactive messages">
            <b-form-select v-model="bot_info.deployment_config.twiliocontentapi"
              :options="yesornooptions"></b-form-select>

          </b-form-group>

          <b-row>
            <b-col lg="2"></b-col>

            <b-col>
              <b-button @click="updateBot" :disabled="isBusy" variant="success" class="wide-button">Update Deployment
                Info</b-button>
            </b-col>

            <b-col>
              <b-button @click="shopInitClick" :disabled="isBusy || bot_info.is_updating" class="wide-button"
                variant="danger">{{
                  bot_info.is_pending ? "Install Bot" : "Restart Bot"
                }}</b-button>
            </b-col>

            <b-col></b-col>
          </b-row>
        </b-card>
      </b-tab>




      <b-tab title="Logic Editor" style="
          width: 88vw;
          height: 90vh;
          padding-bottom: 160px;
          margin-bottom: -5vh;
        " class="bg-dark">

        <b-row style="height: 2%" class="bg-dark" v-if="!isBusy">

          <b-col>

            <b-select v-model="selectedIntentId" :options="bot_info.service_data.intents" class="bg-dark"
              style="width: 90%; margin-left: 3vw; margin-top: 3vh" value-field="id" text-field="name"
              @change="changeIntent">
            </b-select>

          </b-col>

          <b-col>

            <b-row>




              <b-col>

                <b-button v-if="currentIntent" variant="danger" style="width: 90%; margin-left: 3vw; margin-top: 3vh"
                  @click="deleteIntent">
                  Delete Intent
                </b-button>

              </b-col>




              <b-col lg="4" v-if="!currentIntent">
                <p>Please choose an intent from the drop-down</p>

              </b-col>


            </b-row>



          </b-col>

          <b-col>
            <i class="fa fa-check" @click="applyChanges"
              style="margin-top: 3vh; font-size:35px; color:aqua;margin-left: 19px;"
              v-if="savePending && currentIntent"></i>

            <i class="fa fa-check" @click="applyChanges"
              style="margin-top: 3vh; font-size:35px; color: grey;margin-left: 19px;"
              v-if="!savePending && currentIntent"></i>

            <i class="fa loading fa-spinner fa-spin"
              style="margin-top: 3vh; font-size:35px; color: white; margin-left: 19px;" v-if="isBusyService"></i>
          </b-col>

        </b-row>
        <br>

        <b-row style="height: 70vh" class="bg-dark" v-if="!isBusy && currentIntent">

          <div v-if="currentIntent.meta" style="width:90%; margin: 2vw;">

            <b-tabs class="bg-dark">


              <b-tab title="Actions" class="bg-dark">

                <b-row style="margin-top: 13px; margin-bottom: 9px;">
                  <b-col md="8">
                    <span>This is the list of actions performed by your bot. Drag the items to reorder them. Click on the
                      arrow to hide or show.</span>
                  </b-col>
                  <b-col></b-col>
                  <b-col></b-col>

                  <b-col md="2">
                    <b-button @click="addAction()" variant="success">New Action</b-button>
                  </b-col>

                </b-row>

                <draggable v-model="currentIntent.meta.actions" style="margin-top: 7px">
                  <b-card v-for="(action, actionidx) in currentIntent.meta.actions" :key="actionidx" class="bg-dark">
                    <b-card-header>
                      <b-row>
                        <b-col v-if="action.action_type == 'utter'">

                          <UtterAction :dataChangedEvent="dataChangedEvent" :actionData="action"
                            :conditionsData="action.conditions" :actionidx="actionidx"
                            :alternativesData="action.alternatives" :slotsData="bot_info.service_data.slots"
                            :valuesData="action.values" :languages="bot_info.service_data.languages">
                          </UtterAction>
                        </b-col>

                        <b-col v-if="action.action_type == 'api_call'">
 
                          <ApiAction :dataChangedEvent="dataChangedEvent" :actionData="action.action_data"
                            :conditionsData="action.conditions" :actionidx="actionidx"
                            :slotsData="bot_info.service_data.slots" :valuesData="action.values"
                            :languages="bot_info.service_data.languages" :headersData="action.action_data.header_data"
                            :paramsData="action.action_data.request_data.args"
                            :actionItem="action"
                            />

                            <b-form-group id="input-group-8" label="Await User Input:" label-for="input-8"
                                            description="Whether send response and wait for user input after this action">


                              <b-form-checkbox v-model="action.await_input"  @change="dataChangedEvent()" switch></b-form-checkbox>
                                            

                           

                            </b-form-group>

                        </b-col>
 
                        <b-col v-if="action.action_type == 'media_call'">
 
                          <MediaAction :dataChangedEvent="dataChangedEvent" :actionData="action.action_data"
                            :conditionsData="action.conditions" :actionidx="actionidx"
                            :slotsData="bot_info.service_data.slots" :valuesData="action.values"
                            :languages="bot_info.service_data.languages" :headersData="action.action_data.header_data"
                            :paramsData="action.action_data.request_data.args" 
                            />

                            <b-form-group id="input-group-8" label="Await User Input:" label-for="input-8"
                                            description="Whether send response and wait for user input after this action">


                              <b-form-checkbox v-model="action.await_input"  @change="dataChangedEvent()" switch></b-form-checkbox>
                                            

                            </b-form-group>

                        </b-col>

                        <b-col v-if="action.action_type == 'form_input'">

                          <FormInputAction :dataChangedEvent="dataChangedEvent" :actionData="action.action_data"
                            :conditionsData="action.conditions" :actionidx="actionidx"
                            :slotsData="bot_info.service_data.slots" :valuesData="action.values"
                            :languages="bot_info.service_data.languages" 
                            />

                            <b-form-group id="input-group-8" label="Await User Input:" label-for="input-8"
                                            description="Whether send response and wait for user input after this action">


                              <b-form-checkbox v-model="action.await_input"  @change="dataChangedEvent()" switch></b-form-checkbox>
                                            

                           

                            </b-form-group>

                            <b-form-group id="input-group-9" label="Expected Type:" label-for="input-9"
                                            description="Expected Type">
                                            
                              <b-form-select @change="dataChangedEvent()" id="input-9" v-model="action.action_data.expected_type" value-field="text" text-field="value"
                                :options="expected_types" required>
                              </b-form-select>

                            </b-form-group>

                        </b-col>

                        <b-col v-if="action.action_type == 'form'">
 
                          <FormAction :dataChangedEvent="dataChangedEvent" :actionData="action.action_data"
                            :conditionsData="action.conditions" :actionidx="actionidx"
                            :slotsData="bot_info.service_data.slots" :valuesData="action.values"
                            :languages="bot_info.service_data.languages"
                            
                            />
                            <b-form-group id="input-group-8" label="Await User Input:" label-for="input-8"
                                            description="Whether send response and wait for user input after this action">


                              <b-form-checkbox v-model="action.await_input"  @change="dataChangedEvent()" switch></b-form-checkbox>
                                            

                           

                            </b-form-group>



                        </b-col>

                      </b-row>
                    </b-card-header>

                    <b-card-body>
                      Click arrow to reveal/hide
                    </b-card-body>

                    <b-card-footer class="bg-dark">

                      <b-button @click="deleteAction(action, actionidx)" variant="warning">Delete Action</b-button>

                    </b-card-footer>
                  </b-card>
                </draggable>

              </b-tab>

              <b-tab title="Examples" class="bg-dark">

                <b-row>
                  <b-col>

                    <div v-for="(example, exampleidx) in currentIntent.examples" :key="exampleidx">

                      <EgItem :egData="example" :slotsData="bot_info.service_data.slots"
                        :dataChangedEvent="dataChangedEvent" :exampleDeletedEvent="deleteExample"
                        :languages="bot_info.service_data.languages" :idx="exampleidx"></EgItem>

                    </div>

                  </b-col>

                  <b-col md="2">
                    <b-button @click="addExample()" variant="success">New Example</b-button>
                  </b-col>

                </b-row>



              </b-tab>

              <b-tab title="general" class="bg-dark">

                <div v-if="currentIntent">

                  <b-form-group id="input-group-1" label="Intent Name:" label-for="input-1"
                    description="No special characters eg. my_intent">
                    <b-form-input id="input-1" v-model="currentIntent.name" placeholder="Enter Name"
                      required></b-form-input>
                  </b-form-group>

                </div>


              </b-tab>

            </b-tabs>



          </div>

        </b-row>


      </b-tab>



      <b-tab title="Data Editor" style="
          width: 88vw;
          height: 90vh;
          padding-bottom: 160px;
          margin-bottom: -5vh;
        " class="bg-dark">

        <div>

          <b-row v-if="bot_info">

            <b-col>

              <b-card class="bg-dark" style="width: 99%; margin: 5px" title="Add a new intent">

                Intents are the main way your bot understands what your users are saying. You can add as many as you want.
                You can also add examples to each intent to help your bot understand what your users are saying.
                The new intent will be added to the bottom of the list. Switch to the Logic Editor to add logic to your
                intents.

                <br><br>

                <b-card-footer class="bg-dark">

                  <b-button style="width: 100%; margin: 5px" @click="addIntent" class="bg-dark">Add Intent</b-button>

                </b-card-footer>

              </b-card>

            </b-col>

            <b-col>

              <b-card class="bg-dark" style="width: 99%; margin: 5px" title="Download / Upload YAML">

                <p>You can upload a YAML file to quickly add intents and examples to your bot. The YAML file must be
                  properly
                  formatted. You can download a sample YAML file to see how it should be formatted. You can also download
                  your
                  current YAML file to make changes and upload it again.
                </p>


                <b-card-footer class="bg-dark">

                  <b-row>

                    <b-col>

                      <b-button style="width: 90%; margin: 5px" @click="initUploadYaml" variant="primary">Upload
                        YAML</b-button>

                    </b-col>

                    <b-col>

                      <b-button style="width: 90%; margin: 5px" @click="initUploadJson" variant="primary">Upload
                        JSON</b-button>

                    </b-col>

                    <b-col>

                      <b-button style="width: 90%; margin: 5px" @click="yamlDownload" class="bg-dark">Download
                        YAML</b-button>
                    </b-col>

                    <b-col>
                      <b-button style="width: 90%; margin: 5px" @click="jsonDownload" variant="success">Download
                        JSON</b-button>
                    </b-col>
                  </b-row>




                </b-card-footer>

              </b-card>

            </b-col>




          </b-row>

          <br>

          <b-row v-if="bot_info">

            <b-col>


              <b-card class="bg-dark" v-if="bot_info.service_data" title="Slots">

                <b-card-body>
                  <p>
                    Slots are a way for your bot to store and keep track of
                    information. Use them wisely to help your bot seem more
                    natural. Default slots cannot be deleted
                  </p>

                  <div v-if="renderSlots">
                    <b-row v-for="(slot, slotidx) in bot_info.service_data.slots" :key="slot.name" style="margin: 7px">
                      <b-col>
                        {{ slot.name }}
                      </b-col>

                      <b-col lg="2">
                        <b-button @click="deleteSlot(slotidx)" :disabled="slot.default" variant="danger">Delete</b-button>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>

                <b-card-footer class="bg-dark">
                  <b-button style="width: 100%" @click="addSlot" class="bg-dark">Add Slot</b-button>
                </b-card-footer>
              </b-card>


            </b-col>

          </b-row>

          <br>


          <b-row>






          </b-row>

          <br>


          <b-row v-if="bot_info">

            <b-col>

              <b-card class="bg-dark" v-if="bot_info.service_data" title="deployment">

                <b-card-body>
                  <p>
                    Load your updated configurations onto your bot's different environments.
                    Please test in dev before deploying to production. This will take about 5 minutes to complete.
                    Separating the
                    environments allows you to test your changes before deploying to production and making them live.
                  </p>
                </b-card-body>

                <b-card-footer class="bg-dark">

                  <b-row>

                    <b-col>

                      <b-button @click="botPushChange('dev')" :disabled="isBusy || bot_info.is_pending"
                        style="width: 100%;margin: 5px;" class="bg-dark">Push changes dev</b-button>

                    </b-col>

                    <b-col>

                      <b-button @click="botPushChange('prod')" :disabled="isBusy || bot_info.is_pending" variant="danger"
                        style="width: 100%; margin: 5px">Push changes live</b-button>

                    </b-col>
                  </b-row>






                  <vue-loaders-ball-beat v-if="isBusyService" color="white" scale="1"></vue-loaders-ball-beat>
                </b-card-footer>
              </b-card>


            </b-col>


          </b-row>









        </div>


      </b-tab>

      <b-tab title="Languages" style="
          width: 85vw;
          height: 90vh;
          padding-bottom: 160px;
          margin-bottom: -5vh;
        " class="bg-dark">

        <b-card title="Bot Languages" v-if="!isBusy" class="bg-dark">
          <p>Your bot can speak multiple languages, just add one to continue.</p><br>



          <div v-if="!toAddLang">
            <b-row v-for="language in bot_info.service_data.languages" :key="language.code" style="margin: 7px;">
              <b-col>
                <b>Language:</b> {{ language.name }} <b></b>

              </b-col>

              <b-col>

                <b>Code:</b> {{ language.code }} <b></b>
              </b-col>

              <b-col>
                <b>Default:</b> {{ language.default ? "Yes" : "No" }}
              </b-col>

              <b-col>
                <b-button :disabled="language.default" @click="deleteLanguage(language)"
                  variant="danger">Delete</b-button>
              </b-col>

            </b-row>
          </div>

          <b-card-footer class="bg-dark">
            <b-button v-if="!toAddLang" @click="initAddLanguage()" variant="success">Add Language</b-button>

            <div v-if="toAddLang">

              <b-form-group id="input-group-1" label="Name:" label-for="input-1"
                description="Your language name eg. English">
                <b-form-input id="input-1" v-model="new_language.name" placeholder="Enter Name" required></b-form-input>
              </b-form-group>

              <b-form-group id="input-group-2" label="Code:" label-for="input-2" description="Your language code eg. en">
                <b-form-input id="input-2" v-model="new_language.code" placeholder="Enter Code" required></b-form-input>
              </b-form-group>

              <b-form-group id="input-group-3" label="Default:" label-for="input-3"
                description="Whether this is the default language">
                <b-form-select id="input-3" v-model="new_language.default" :options="trueorfalsetext"
                  required></b-form-select>
              </b-form-group>

              <b-row>

                <b-col>

                  <b-button :disabled="isBusy || !new_language.name || !new_language.code" @click="submitLanguage"
                    style="width: 100%">Save Language</b-button>

                </b-col>

                <b-col>

                  <b-button @click="cancelAddLanguage" style="width: 100%" variant="danger">Cancel</b-button>

                </b-col>

              </b-row>





            </div>
          </b-card-footer>

        </b-card>

      </b-tab>





      <b-tab title="How To Use" style="width: 85vw" class="bg-dark">
        <b-card class="bg-dark" v-if="!isBusy">
          <b-card-header>
            <h4>Using Your Bot</h4>
          </b-card-header>

          <b-card-body>
            <div style="margin-top: 23px" v-if="bot_info.service_urls.length > 0">
              <hr class="bg-dark" />

              <p>Here you can test how your bot responds to your prompts in order to quickly try out your changes. You can
                switch between live and test environments easily using the selector. </p>

              <hr class="bg-dark" />

              <div style="height: 55vh; padding: 7px;">

                <div class="bg-dark" style="height: 90%; overflow-y: scroll;">

                  <b-card v-for='message in chatMessages' :key='message.id' :class="getCardClass(message)"
                    :style="getCardStyle(message)">

                    <b-card-body>
                      <b-row>
                        <b-col>
                          <b-card-img v-if="message.media">
                            <img :src="message.media" />
                          </b-card-img>
                          <b-card-text>
                            {{ message.text }}
                          </b-card-text>
                        </b-col>
                      </b-row>




                    </b-card-body>

                  </b-card>

                  <b-row v-if="isBotBusy"><vue-loaders-ball-beat color="red" scale="1"></vue-loaders-ball-beat></b-row>

                </div>

                <div style="margin-top: 33px;">

                  <b-row>

                    <b-col lg="2">

                      <b-form-select id="input-env" v-model="currentTestEnv" :options="envTypes" required
                        @change="changeEnv"></b-form-select>





                    </b-col>
                    <b-col>
                      <b-form-input v-model="chatMessage" placeholder="Enter Message"></b-form-input>
                    </b-col>

                    <b-col>
                      <b-button @click="onSubmitText" :disabled="isBotBusy || !chatMessage" variant="success"
                        class="wide-button">Send Message</b-button>
                    </b-col>


                  </b-row>
                </div>



              </div>


            </div>

            <br />


          </b-card-body>

          <b-card-footer class="bg-dark">
            <p>
              Here are links to access your bot and connecting to various
              channels. The links with a 'dev' suffix are the development
              links while the 'prod' are the production links. Ensure that you
              only push changes to live when you have fully tested on dev
              first.
            </p>
            <div>
              <b-row v-for="item in bot_info.service_urls" :key="item" style="margin-bottom: 13px">
                <b-col>
                  <p><b>web:</b> {{ item }}/botapi/v1/default-channel/ask</p>
                </b-col>

                <b-col>
                  <p>
                    <b>whatsapp:</b> {{ item }}/botapi/v1/whatsapp-channel/ask
                  </p>
                </b-col>
              </b-row>
            </div>
          </b-card-footer>
        </b-card>
      </b-tab>
    </b-tabs>
  </b-row>
</template>

<script>
import draggable from "vuedraggable";
import YAML from 'yamljs';


import {
  createItemJsonPost,
  createMediaItemJsonPost,
  createGeneralItemJsonPost,
  getTableData,
  uploadItem,
  downloadItem,
  uploadItemFetchAsync
} from "../../services/v1/api_store";
import { DEFAULT_TOAST } from "../../services/v1/constants";

import UtterAction from "../../components/UtterAction";

import EgItem from "../../components/EgItem";

import ApiAction from "../../components/ApiAction";

import MediaAction from "../../components/MediaAction";

import FormInputAction from "../../components/FormInputAction";

import FormAction from "../../components/FormAction";


const opts = DEFAULT_TOAST;

export default {
  name: "Bot",
  components: {
    draggable,
    UtterAction,
    EgItem,
    ApiAction,
    MediaAction,
    FormInputAction,
    FormAction
  },
  async mounted() {
    let self = this;
    getTableData(
      this.$store,
      `users/bots/${this.$route.params.id}/info`,
      (text) => this.handleStoreDataLoaded(text)
    );

    this.$eventHub.$on("storeCompletedEvent", (show) =>
      getTableData(this.$store, `users/bots/${this.$route.params.id}/info`, (text) =>
        self.partialUpdate(text)
      )
    );
  },
  beforeDestroy() {
    this.$eventHub.$off("storeCompletedEvent");
  },
  props: {
    caption: {
      type: String,
      default: "Bot",
    },
  },
  computed: {
    nonDefaultSlots() {
      if (
        this.bot_info.service_data == null ||
        this.bot_info.service_data.slots == null
      ) {
        return [];
      }

      return this.bot_info.service_data.slots.filter(
        (slot) => slot.default !== true
      );
    },
  },
  data: () => {
    return {
      records: {},
      isBusy: true,
      isBusy2: true,
      isBusy3: false,
      boolOptions: [
        { text: "Yes", value: true },
        { text: "No", value: false },
      ],
      yesornooptions: [
        { text: "Yes", value: "yes" },
        { text: "No", value: "no" },
      ],
      trueorfalsetext: [
        { text: "True", value: true },
        { text: "False", value: false },
      ],
      results: {},
      fields: [{ key: "key" }, { key: "value" }],
      results: {},
      recent_caps: [],
      current_media: null,
      current_file_name: null,
      current_ts: null,
      fields: [
        { key: "log_id" },
        { key: "message" },
        { key: "success" },
        { key: "date_created" },
      ],
      currentPage: 1,
      perPage: 5,
      logs_items: [],
      languages: [
        {
          name: "english",
          code: "en",
        },
      ],
      isBotBusy: false,
      chatMessages: [
        {
          'text': "Hi, type a message to begin",
          isMine: false,
          author: 'Bot',
          id: Math.random().toString(36).substring(7)
        },
      ],
      chatMessage: '',
      currentTestEnv: "dev",
      renderSlots: true,
      selectedActionType: "utter",
      currentIntent: null,
      conditionTypes: [
        {
          text: "is not set",
          value: "slot_value_unset",
        },
        {
          text: "Equals",
          value: "slot_value_equal_to",
        },
        {
          text: "Is in list",
          value: "slot_value_in_list",
        },
      ],
      new_condition: {
        condition_type: "slot_value_unset",
        slot: "",
        value: "",
      },
      actionTypes: [
        {
          name: "utter",
          value: "utter",
        },
        {
          name: "api_call",
          value: "api_call",
        },
        {
          name: "media_call",
          value: "media_call",
        },
        {
          name: "form_input",
          value: "form_input",
        },
        {
          name: "form",
          value: "form",
        },
      ],
      slotTypes: [
        {
          text: "text",
          value: "text",
        },
        {
          text: "number",
          value: "number",
        },
        {
          text: "float",
          value: "float",
        },
        {
          text: "date",
          value: "date",
        },
        {
          text: "time",
          value: "time",
        },
        {
          text: "datetime",
          value: "datetime",
        },
        {
          text: "email",
          value: "email",
        },
        {
          text: "phone",
          value: "phone",
        },
        {
          text: "list",
          value: "list",
        },
      ],
      resultTypes: [
        {
          text: "list",
          value: "list",
        },
        {
          text: "object",
          value: "object",
        },
      ],
      requestTypes: [
        {
          text: "GET",
          value: "GET",
        },
        {
          text: "POST",
          value: "POST",
        },
      ],
      formInputTypes: [
        {
          text: "text",
          value: "text",
        },
        {
          text: "numeric",
          value: "numeric",
        },
      ],
      new_arg: {
        key: "",
        value: "",
      },
      new_arg_header: {
        key: "",
        value: "",
      },
      envTypes: [
        {
          text: "dev",
          value: "dev",
        },
        {
          text: "prod",
          value: "prod",
        },
      ],
      yamluploaded: null,
      new_slot: {},
      new_value: {},
      new_action: {},
      showNested: false,
      renderConditions: false,
      selectedIntentId: null,
      renderArgs: true,
      domain_to_delete: "",
      all_shop_domains: [],
      toAddLang: false,
      new_language: {
        name: "",
        code: "",
        default: false,
      },
      expected_types: [
        {
          text: "text",
          value: "text",
        },
        {
          text: "numeric",
          value: "numeric",
        },
        {
          text: "media_upload",
          value: "media_upload",
        },
        
      ],
      logo: null,
      logo_small: null,
      favicon: null,
      bot_info: null,
      isBusyService: false,
      savePending: false,
      processing: false,
      soft_restart_warning:
        "You are about to reload your bot. This will apply any minor changes you have made to the bot and should take about 5 minutes to reflect.",
      install_warning:
        "You are about to install your bot. This will make it accessible and you can then start adding logic to it.",
      restart_warning:
        "Are you sure you want to perform this action? You can only perform this action a limited number of times per day.",
    };
  },
  methods: {

    initActionDataComponent(evt) {

      console.log('init action data component');

      console.log(evt);

      this.currentIntent.meta.actions[evt.actionidx].action_data.alternatives = [];
    },
    deleteLanguage(language) {

      this.bot_info.service_data.languages = this.bot_info.service_data.languages.filter(
        (lang) => lang.code != language.code
      );

      this.applyChanges();
    },

    submitLanguage() {

      this.bot_info.service_data.languages.push(this.new_language);

      this.toAddLang = false;

      this.applyChanges();
    },
    initAddLanguage() {
      this.toAddLang = true;
    },
    cancelAddLanguage() {
      this.toAddLang = false;
    },
    deleteExample(idx) {

      console.log(idx);
      this.currentIntent.examples.splice(idx, 1);

      this.$eventHub.$emit("storeEvent", this.bot_info);
    },
    dataChangedEvent() {
      console.log('data changed');
      this.savePending = true;
    },
    applyChanges() {
      this.savePending = false;

      this.bot_info.service_data.intents[this.currentItentIdx] = this.currentIntent;

      this.$eventHub.$emit("storeEvent", this.bot_info);

      setTimeout(() => {
        this.savePending = false;
        this.updateServiceData();
      }, 2000);
    },
    changeIntent(evt) {
      console.log(evt);

      this.selectedIntentId = evt;

      this.currentItentIdx = this.bot_info.service_data.intents.findIndex(
        (intent) => intent.id == evt
      );

      console.log(this.currentItentIdx);

      // this.currentIntent = this.bot_info.service_data.intents[
      //   this.currentItentIdx
      // ];

      const currentIntent = this.bot_info.service_data.intents[
        this.currentItentIdx
      ];


      // loop through the actions and check if they are of type form

      // if they are of type form, then we need to add the alternatives array

      // if current intent is of type form, then we need to add the alternatives array

      if (currentIntent.meta.actions.length > 0) {
          
          currentIntent.meta.actions.forEach((action, actionidx) => {
  
            if (action.action_type == 'form') {
  
              if (!action.action_data.hasOwnProperty('alternatives')) {
  
                currentIntent.meta.actions[actionidx].action_data.alternatives = [];

                console.log('added alternatives');
  
              }
  
            }
  
          });
  
        }

        this.currentIntent = currentIntent;



    },
    partialUpdate(show) {
      this.bot_info.is_updating = false;
    },
    changeEnv(env) {
      this.currentTestEnv = env;
      this.chatMessages = [
        {
          'text': "Hi, type a message to begin",
          isMine: false,
          author: 'Bot',
          id: Math.random().toString(36).substring(7)
        },
      ];
    },
    getCardClass(item) {
      if (item.isMine) {
        return "bg-primary";
      } else {
        return "bg-danger";
      }
    },
    getCardStyle(item) {
      if (item.isMine) {
        return "width: 70%; height: 140px;";
      } else {
        return "width: 70%; height: 140px; float: right";
      }
    },
    initUploadYaml() {
      this.showNested = true;

      this.$refs.uploadyamlmodal.open();
    },
    initUploadJson() {
      this.showNested = true;

      this.$refs.uploadjsonmodal.open();
    },
    async submitYaml(evt) {
      evt.preventDefault();

      const formData = new FormData();

      const inputYamlFile = document.getElementById("yamlupload");

      formData.append("file", inputYamlFile.files[0]);

      this.isBusy = true;

      const response = await uploadItemFetchAsync(
        this.$store,
        `users/bots/${this.$route.params.id}/upload_yaml`,
        formData
      );

      this.isBusy = false;

      const updatedConf = await response.json();

      if (updatedConf.status == "error") {
        this.$toasted.show('Sorry upload was unsuccessful', opts);
        return;
      }

      console.log(updatedConf.data);

      this.bot_info.service_data = updatedConf.data;

      

      this.$refs.uploadyamlmodal.close();

      this.$toasted.show("Submission Successful", opts);


      /*uploadItem(
        this.$store,
        `users/bots/${this.$route.params.id}/upload_yaml`,
        formData,
        (text) => this.yamlUploadProgressCallback(text),
        (text) => this.yamlUploadCompleteCallback(text)
      );*/
    },
    async submitJson(evt) {
      evt.preventDefault();

      const formData = new FormData();

      const inputYamlFile = document.getElementById("jsonupload");

      formData.append("file", inputYamlFile.files[0]);

      this.isBusy = true;

      const response = await uploadItemFetchAsync(
        this.$store,
        `users/bots/${this.$route.params.id}/upload_json`,
        formData
      );

      this.isBusy = false;

      const updatedConf = await response.json();

      if (updatedConf.status == "error") {
        this.$toasted.show('Sorry upload was unsuccessful', opts);
        return;
      }

      console.log(updatedConf.data);

      this.bot_info.service_data = updatedConf.data;

      this.$refs.uploadjsonmodal.close();

      this.$toasted.show("Submission Successful", opts);
    },
    async loadInfo() {
      getTableData(
        this.$store,
        `users/bots/${this.$route.params.id}/info`,
        (text) => this.handleStoreDataLoaded(text)
      )
    },
    async yamlUploadProgressCallback(prog) {
      console.log(prog);

      if (prog > 98) {
        this.$toasted.show("Submission Successful", opts);
        // this.isBusy = false;
        this.$refs.uploadyamlmodal.close();

        await this.loadInfo();
      }
    },

    yamlUploadCompleteCallback(prog) {
      console.log('done');
    },
    addArg() {
      this.new_arg.key = this.new_arg.key.trim();
      this.new_arg.value = this.new_arg.value.trim();
      if (this.new_arg.key.length > 0 && this.new_arg.value.length > 0) {
        this.new_action.action_data.request_data.args[this.new_arg.key] =
          this.new_arg.value;
        this.new_arg = { key: "", value: "" };
      }
    },
    addHeader() {
      this.new_arg_header.key = this.new_arg_header.key.trim();
      this.new_arg_header.value = this.new_arg_header.value.trim();
      if (this.new_arg_header.key.length > 0 && this.new_arg_header.value.length > 0) {
        this.new_action.action_data.header_data[this.new_arg_header.key] =
          this.new_arg_header.value;
        this.new_arg_header = { key: "", value: "" };
      }
    },
    submitAction() {
      console.log(this.new_action);

      this.bot_info.service_data.intents[
        this.currentItentIdx
      ].meta.actions.push(this.new_action);

      this.$refs.actionmodal.close();
    },
    changeActionType(actionType) {
      this.selectedActionType = actionType;

      console.log(actionType);

      this.new_action = this.generateAction(this.selectedActionType);
    },
    removeRequestData(k) {
      console.log(k);
      if (this.new_action.action_data.request_data.args.hasOwnProperty(k)) {
        delete this.new_action.action_data.request_data.args[k];
        console.log("key removed");

        this.renderArgs = false;
        this.renderArgs = true;
      } else {
        console.log("key not found");
      }
    },
    removeHeaderData(k) {
      console.log(k);
      if (this.new_action.action_data.header_data.hasOwnProperty(k)) {
        delete this.new_action.action_data.header_data[k];
        console.log("key removed");

        this.renderArgs = false;
        this.renderArgs = true;
      } else {
        console.log("key not found");
      }
    },
    generateAction(type) {
      if (type == "utter") {
        return {
          action_type: "utter",
          action_data: "",
          paraphrase: {
            enabled: false,
            degree: 0.0,
          },
          alternatives: [],
          conditions: [],
          values: [],
          await_input: true,
        };
      } else if (type == "api_call") {
        return {
          action_type: "api_call",
          action_data: {
            endpoint: "",
            request_type: "GET",
            request_data: {
              args: {},
            },
            header_data: {},
            result_type: "list",
            result_key: "",
            slot: "",
            display_message: "",
            error_msg: "oops! something went wrong",
          },
          conditions: [],

          await_input: true,
        };
      } else if (type == "form_input") {
        return {
          conditions: [],
          action_type: "form_input",
          action_data: {
            expected_type: "text",
            slot: "",
            display_message: "",
            error_message: "oops! something went wrong",
          },
          conditions: [],
          await_input: true,
        };
      } else if (type == "media_call") {
        return {
          conditions: [],
          action_type: "media_call",
          action_data: {
            endpoint: "",
            request_type: "GET",
            request_data: {
              args: {},
            },
            header_data: {},
            display_message: "",
            error_msg: "oops! something went wrong",
          },
          await_input: true,
        };
      } else if (type == "form") {
        return {
          conditions: [],
          action_type: "form",
          action_data: {
            display_message: "",
            error_message: "oops! something went wrong",
            options: "",
            display_key: "",
            alternatives: []
          },
          await_input: true,
        };
      }
    },
    addAction(idx) {
      this.currentItentIdx = idx;

      this.new_action_utter = {
        action_type: "utter",
        action_data: "",
        paraphrase: {
          enabled: false,
          degree: 0.0,
        },
        alternatives: [],
        conditions: [],
        values: [],
        await_input: true,
      };

      this.new_action = this.generateAction(this.selectedActionType);

      this.showNested = true;

      this.$refs.actionmodal.open();
    },
    appendAction() {

      this.currentIntent.meta.actions.push(this.new_action);

      this.$refs.actionmodal.close();

      this.showNested = false;

      this.renderConditions = false;

      this.renderConditions = true;
    },
    deleteAction(action, actionidx) {

      console.log(action, actionidx)

      this.currentIntent.meta.actions.splice(actionidx, 1);
    },

    deleteCondition(idx, actionidx, conditionidx) {
      this.bot_info.service_data.intents[idx].meta.actions[
        actionidx
      ].conditions.splice(conditionidx, 1);
      this.renderConditions = false;
      this.renderConditions = true;
    },
    deleteValue(idx, actionidx, valueidx) {
      this.bot_info.service_data.intents[idx].meta.actions[
        actionidx
      ].values.splice(valueidx, 1);
      this.renderConditions = false;
      this.renderConditions = true;
    },
    getNonDefaultSlots() {
      if (
        this.bot_info.service_data == null ||
        this.bot_info.service_data.slots == null
      ) {
        return [];
      }

      return this.bot_info.service_data.slots.filter(
        (slot) => slot.default !== true
      );
    },
    submitCondition() {
      console.log(this.new_condition);

      if (
        this.bot_info.service_data.intents[this.currentItentIdx].meta.actions[
          this.currentActionIdx
        ].conditions == null
      ) {
        this.bot_info.service_data.intents[this.currentItentIdx].meta.actions[
          this.currentActionIdx
        ].conditions = [];
      }

      this.bot_info.service_data.intents[this.currentItentIdx].meta.actions[
        this.currentActionIdx
      ].conditions.push(this.new_condition);

      console.log(
        this.bot_info.service_data.intents[this.currentItentIdx].meta.actions[
          this.currentActionIdx
        ].conditions
      );

      this.renderConditions = false;

      // this.showNested = false;

      // this.$refs.conditionmodal.close();

      this.renderConditions = true;
    },
    submitValue() {
      console.log(this.new_value);

      if (
        this.bot_info.service_data.intents[this.currentItentIdx].meta.actions[
          this.currentActionIdx
        ].values == null
      ) {
        this.bot_info.service_data.intents[this.currentItentIdx].meta.actions[
          this.currentActionIdx
        ].values = [];
      }

      this.bot_info.service_data.intents[this.currentItentIdx].meta.actions[
        this.currentActionIdx
      ].values.push(this.new_value);

      console.log(
        this.bot_info.service_data.intents[this.currentItentIdx].meta.actions[
          this.currentActionIdx
        ].values
      );

      this.renderConditions = false;

      this.showNested = false;

      this.$refs.valuemodal.close();

      this.renderConditions = true;
    },
    addActionCondition(idx, actionIdx) {
      this.currentItentIdx = idx;
      this.currentActionIdx = actionIdx;

      this.new_condition = {
        condition_type: "slot_value_unset",
        slot: "",
        value: "",
      };

      this.showNested = true;

      this.$refs.conditionmodal.open();
    },
    addActionValue(idx, actionIdx) {
      this.currentItentIdx = idx;
      this.currentActionIdx = actionIdx;

      this.new_value = {
        slot: "",
        symbol: "",
      };

      this.showNested = true;

      this.$refs.valuemodal.open();
    },
    deleteSlot(idx) {
      console.log(idx);
      this.bot_info.service_data.slots.splice(idx, 1);
      this.renderSlots = false;
      this.renderSlots = true;
    },
    submitSlot() {
      this.renderSlots = false;
      this.bot_info.service_data.slots.push(this.new_slot);
      this.$refs.slotmodal.close();
      this.renderSlots = true;
    },
    addSlot() {
      this.showNested = true;
      this.new_slot = {
        name: "",
        default: false,
        type: "text",
      };
      this.$refs.slotmodal.open();
    },
    randomString(len) {
      var p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      return [...Array(len)].reduce(
        (a) => a + p[~~(Math.random() * p.length)],
        ""
      );
    },
    deleteIntent() {
      // this.bot_info.service_data.intents[this.currentItentIdx] 
      this.bot_info.service_data.intents.splice(this.currentItentIdx, 1);
      this.currentIntent = null;
      this.currentItentIdx = null;
    },
    addIntent() {
      this.bot_info.service_data.intents.push({
        name: "new_intent",
        id: this.$route.params.id + this.randomString(28),
        bot_id: this.$route.params.id,
        examples: [],
        meta: { actions: [] },
      });

      // toast

      this.$toasted.show("Intent Added", opts);
    },
    addExample() {
      this.currentIntent.examples.push({
        text: "",
        language: "en",
        entities: [],
      });
    },

    stringTOId(str, egidx) {
      return str + "-" + egidx;
    },
    cancelDelete() {
      this.$refs.deletedomainmodal.close();
    },
    addDomain() {
      this.showNested = true;
      this.$refs.domainmodal.open();
    },
    deleteDomainClicked(name) {
      this.domain_to_delete = name;
      this.$refs.deletedomainmodal.open();
    },
    submitDomain() {
      this.isBusy = true;
      const item = {
        name: this.new_domain,
        id: this.$route.params.id,
      };
      createItemJsonPost(this.$store, `users/shops/add_domain`, item, (text) =>
        this.onDomainCreateComplete(text)
      );
    },

    assetsUpload(evt) {
      evt.preventDefault();

      const formData = new FormData();

      const inputLogoFile = document.getElementById("logoupload");

      const inputLogoSmallFile = document.getElementById("logosmallupload");

      const inputFaviconFile = document.getElementById("faviconupload");

      formData.append("shop_id", this.$route.params.id);

      formData.append("logo", inputLogoFile.files[0]);

      formData.append("logo_small", inputLogoSmallFile.files[0]);

      formData.append("favicon", inputFaviconFile.files[0]);

      this.isBusy = true;

      uploadItem(
        this.$store,
        `users/bots/upload_custom_assets`,
        formData,
        (text) => this.uploadProgressCallback(text),
        (text) => this.uploadCompleteCallback(text)
      );
    },
    yamlDownload() {
      this.isBusyService = true;

      downloadItem(
        this.$store,
        `users/bots/${this.$route.params.id}/yaml`,
        "yaml",
        (text) => this.downloadCompleteCallback(text)
      );
    },

    jsonDownload() {
      this.isBusyService = true;

      const item = this.bot_info.service_data;

      // download as json in browser

      const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(item));

      const downloadAnchorNode = document.createElement("a");

      downloadAnchorNode.setAttribute("href", dataStr);

      downloadAnchorNode.setAttribute("download", "bot.json");

      document.body.appendChild(downloadAnchorNode); // required for firefox

      downloadAnchorNode.click();

      downloadAnchorNode.remove();

      this.isBusyService = false;

     
    },

    downloadCompleteCallback(text) {
      this.isBusyService = false;
    },

    uploadProgressCallback(prog) {
      console.log(prog);

      if (prog > 98) {
        this.$toasted.show("Submission Successful", opts);
        this.isBusy = false;
      }
    },

    uploadCompleteCallback(prog) { },

    shopReloadClick() {
      this.$refs.reloadshopmodal.open();
    },

    shopInitClick() {
      this.$refs.restartshopmodal.open();
    },
    cancelRestart() {
      this.$refs.restartshopmodal.close();
    },
    cancelReload() {
      this.$refs.reloadshopmodal.close();
    },
    shopDoInit() {
      this.isBusy = true;
      const item = {
        id: this.$route.params.id,
      };
      createItemJsonPost(this.$store, `users/bots/${this.$route.params.id}/initialize`, item, (text) =>
        this.onShopInitComplete(text)
      );
    },
    botPushChange(push_mode) {
      this.isBusyService = true;
      this.bot_info.is_updating = true;
      const item = {
        push_mode: push_mode,
      };
      createItemJsonPost(this.$store, `users/bots/${this.$route.params.id}/push_changes`, item, (text) =>
        this.onBotPushComplete(text)
      );
    },
    shopDoReload() {
      this.isBusy = true;
      const item = {
        id: this.$route.params.id,
      };
      createItemJsonPost(this.$store, `users/bots/soft_restart`, item, (text) =>
        this.onShopReloadComplete(text)
      );
    },
    deleteDomain() {
      this.isBusy = true;
      const item = {
        name: this.domain_to_delete,
        id: this.$route.params.id,
      };
      createItemJsonPost(
        this.$store,
        `users/bots/delete_domain`,
        item,
        (text) => this.onDomainDeleteComplete(text)
      );
    },
    onBotPushComplete(resp) {
      this.isBusyService = false;

      if (resp.code === 200) {
        this.$toasted.show("Submission Successful", opts);
        this.showNested = false;

      } else {
        console.log(resp);

        if (resp.code === 401) {
          this.$toasted.show("Action Failed, unauthorized", opts);
        } else {
          this.$toasted.show(
            "Action Failed: system is currently updating",
            opts
          );
        }
      }
    },
    onShopInitComplete(resp) {
      this.isBusy = false;

      this.$refs.restartshopmodal.close();

      if (resp.code === 200) {
        this.$toasted.show("Submission Successful", opts);
        this.showNested = false;

        let self = this;
        getTableData(
          this.$store,
          `users/bots/${this.$route.params.id}/info`,
          (text) => self.handleStoreDataLoaded(text)
        );
      } else {
        console.log(resp);

        if (resp.code === 401) {
          this.$toasted.show("Action Failed, unauthorized", opts);
        } else {
          this.$toasted.show(
            "Action Failed: system is currently updating",
            opts
          );
        }
      }
    },
    onShopReloadComplete(resp) {
      this.isBusy = false;

      this.$refs.reloadshopmodal.close();

      if (resp.code === 200) {
        this.$toasted.show("Submission Successful", opts);
        this.showNested = false;

        let self = this;
        getTableData(
          this.$store,
          `users/bots/${this.$route.params.id}/info`,
          (text) => self.handleStoreDataLoaded(text)
        );
      } else {
        console.log(resp);

        if (resp.code === 401) {
          this.$toasted.show("Action Failed, unauthorized", opts);
        } else {
          this.$toasted.show(
            "Action Failed: system is currently updating",
            opts
          );
        }
      }
    },
    onDomainDeleteComplete(resp) {
      this.isBusy = false;

      this.$refs.deletedomainmodal.close();

      if (resp.code === 200) {
        this.$toasted.show("Deletion Successful", opts);
        this.showNested = false;

        let self = this;
        getTableData(
          this.$store,
          `users/bots/${this.$route.params.id}/info`,
          (text) => self.handleStoreDataLoaded(text)
        );
      } else {
        console.log(resp);

        if (resp.code === 401) {
          this.$toasted.show(
            "Delete Failed: unauthorized action, report logged ",
            opts
          );
        } else {
          this.$toasted.show("Delete Failed: domain not found", opts);
        }
      }
    },
    onDomainCreateComplete(resp) {
      this.isBusy = false;

      this.$refs.domainmodal.close();

      if (resp.code === 200) {
        this.$toasted.show("Creation Successful", opts);
        this.showNested = false;

        let self = this;
        getTableData(
          this.$store,
          `users/bots/${this.$route.params.id}/info`,
          (text) => self.handleStoreDataLoaded(text)
        );
      } else {
        console.log(resp);

        if (resp.code === 401) {
          this.$toasted.show(
            "Create Failed: unauthorized action, report logged ",
            opts
          );
        } else {
          this.$toasted.show("Create Failed: domain already exists", opts);
        }
      }
    },
    closeNested() {
      console.log("close nested");
    },
    handleStoreDataLoaded(resp) {
      if (resp.code == 200) {
        this.bot_info = resp.response.bot;
        this.isBusy = false;
        if (this.bot_info.service_data.slots == null) {
          this.bot_info.service_data.slots = [
            {
              name: "bot_credentials",
              default: true,
              type: "string",
            },
            {
              name: "userid",
              default: true,
              type: "string",
            },
          ];
        }

        if (this.bot_info.service_data.languages == null) {
          this.bot_info.service_data.languages = [
            {
              name: "English",
              default: true,
              code: "en",
            },
          ];
        }

        // add current_user_lang to this.bot_info.service_data.slots if not present

        const current_user_lang = {
          name: "current_user_lang",
          default: true,
          type: "string",
        };

        if (!this.bot_info.service_data.slots.some(e => e.name === 'current_user_lang')) {
          this.bot_info.service_data.slots.push(current_user_lang);
        }


      }
    },

    updateServiceData() {
      this.isBusyService = true;

      const bot_info = this.bot_info;

      createItemJsonPost(
        this.$store,
        `users/bots/${this.$route.params.id}/update_service_data`,
        bot_info.service_data,
        (text) => this.onServiceDataUpdateComplete(text)
      );
    },
    updateBot() {
      this.isBusy = true;

      // clean up shop name

      // add default values

      const bot_info = this.bot_info;

      const item = {
        twiliosid: bot_info.deployment_config.twiliosid,
        twiliotoken: bot_info.deployment_config.twiliotoken,

        twiliocontentapi: bot_info.deployment_config.twiliocontentapi,
        twiliomessagingsid: bot_info.deployment_config.twiliomessagingsid,

        action_api: bot_info.deployment_config.action_api,
        action_api_key: bot_info.deployment_config.action_api_key,
        telegram_dev: bot_info.deployment_config.telegram_dev,
        telegram_prod: bot_info.deployment_config.telegram_prod,
      };

      createItemJsonPost(this.$store, `users/bots/${this.$route.params.id}/update`, item, (text) =>
        this.onStoreUpdateComplete(text)
      );
    },
    onServiceDataUpdateComplete(resp) {
      this.isBusyService = false;

      if (resp.code === 200) {
        this.$toasted.show("Update Successful", opts);
      } else {
        console.log(resp);

        if (resp.code === 401) {
          this.$toasted.show(
            "Update Failed: unauthorized action, report logged ",
            opts
          );
        } else {
          this.$toasted.show(
            "Update Failed: an unexpected error has occurred",
            opts
          );
        }
      }
    },
    onStoreUpdateComplete(resp) {
      this.isBusy = false;

      if (resp.code === 200) {
        this.$toasted.show("Update Successful", opts);
        this.showNested = false;

        let self = this;
        getTableData(
          this.$store,
          `users/bots/${this.$route.params.id}/info`,
          (text) => self.handleStoreDataLoaded(text)
        );
      } else {
        console.log(resp);

        if (resp.code === 401) {
          this.$toasted.show(
            "Update Failed: unauthorized action, report logged ",
            opts
          );
        } else {
          this.$toasted.show(
            "Update Failed: an unexpected error has occurred",
            opts
          );
        }
      }
    },

    goBack() {
      this.$router.go(-1);
      // this.$router.replace({path: '/users'})
    },
    checkDev(src) {
      return src.indexOf("dev") > -1;
    },
    checkProd(src) {
      return src.indexOf("prod") > -1;
    },
    sendBotMessage(message) {
      this.isBotBusy = true;

      const item = {
        message: message,
        userid: 'admin'
      };

      let serviceAddress = '';

      if (this.currentTestEnv == 'dev') {
        serviceAddress = this.bot_info.service_urls.filter(this.checkDev)[0];

      }
      else if (this.currentTestEnv == 'prod') {
        serviceAddress = this.bot_info.service_urls.filter(this.checkProd)[0];
      }

      const url = `${serviceAddress}/botapi/v1/default-channel/ask`

      createGeneralItemJsonPost(
        url,
        item,
        (text) => this.onBotMessageComplete(text)
      );
    },
    onBotMessageComplete(resp) {
      this.isBotBusy = false;

      if (resp.code === 200) {
        console.log(resp.response.diagnostic.action_res.disp);

        this.chatMessages.push(
          {
            'text': resp.response.diagnostic.action_res.disp,
            isMine: false,
            author: 'Bot',
            media: resp.response.diagnostic.action_res.media ? resp.response.diagnostic.action_res.media : null,
            id: Math.random().toString(36).substring(7)
          },
        )
      }

      else {
        console.log(resp);
      }

    },
    onSubmitText(event, text) {

      const msg = this.chatMessage;

      this.chatMessages.push(
        {
          'text': msg,
          isMine: true,
          author: 'Me',
          id: Math.random().toString(36).substring(7)
        },
      )

      this.sendBotMessage(msg);
    }
  },
};
</script>

<style scoped>
.messages {
  flex-grow: 1;
  overflow: auto;
  padding: 1rem;
}

.message+.message {
  margin-top: 1rem;
}

.message.right {
  margin-left: auto;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
